export default {
    baseStyle: {
        container: {
            padding: 4
        },
        radio: {
            ml: 1
        },
        content: {
            justify: 'space-between',
            w: 'full'
        },
        info: {
            flex: '1'
        },
        defaultLabel: {
            textStyle: 'badge',
            mb: 2
        },
        defaultLabelBorder: {
            display: 'inline-block',
            p: 1,
            border: '1px solid',
            borderColor: 'webTheme.strokeDefault'
        },
        addressLabel: {
            textStyle: 'bodyXsBold',
            mb: 3
        },
        name: {
            textStyle: 'bodyXsSRegular'
        },
        addressLine: {
            textStyle: 'bodyXsSRegular'
        }
    },
    variants: {
        'billingAddress': {
            addressLabel: {
                textStyle: 'bodyXsSBold',
                mb: {base: '14px', lg: 2}
            }
        }
    }
}
